// extracted by mini-css-extract-plugin
module.exports = {"section2":"section2-module--section2--1w4jJ"};